<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapMutations } from "vuex";

import "@fortawesome/fontawesome-free/css/all.css";
import "tailwindcss/tailwind.css";

export default {
  methods: {
    ...mapMutations(["changeUser"]),
  },
  created() {
    if (localStorage.getItem("user")) {
      this.changeUser(JSON.parse(localStorage.getItem("user")));

      this.$router.push("/");
    }
  },
};
</script>

<style>
:focus,
input:focus,
button:focus,
button:hover {
  outline: none;
}
</style>
